"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEnv = exports.isCI = exports.isProduction = exports.isStaging = exports.isTesting = exports.isDevelopment = void 0;
var check = function () {
    var d = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        d[_i] = arguments[_i];
    }
    var env = process.env.ENV === undefined || process.env.ENV === "undefined" ? "" : process.env.ENV;
    return d.some(function (data) { return env === data; });
};
exports.isDevelopment = function () {
    return check("development", "develop", "dev", "d", "");
};
exports.isTesting = function () {
    return check("testing", "tested", "test", "t");
};
exports.isStaging = function () {
    return check("staging", "stage", "stag", "s");
};
exports.isProduction = function () {
    return check("production", "product", "prod", "p");
};
exports.isCI = function () {
    return process.env.CI === "true";
};
exports.setEnv = function (name, value) {
    var old = process.env[name];
    process.env[name] = value;
    return old;
};
//# sourceMappingURL=env.js.map